import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import {StorageKeys} from 'src/app/share/enums/storage.enum';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnChanges  {
  @Input()  options             : any[] = [];
  @Input() addUser              : string;
  @Input() patchValues           : any[] = [];
  @Output() SendSelectedOptions : EventEmitter<any> = new EventEmitter<any>
  selectedOptions               : any[] = [];
  isDropdownOpen                = false;
  selectedOption                = 'Select Role';
  selfDetails                   : any;

  constructor(private readonly elementRef: ElementRef,
    private readonly storageService: StorageService) {
      this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
     }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  ngOnChanges(changes : SimpleChanges){
    if(changes['patchValues']?.currentValue){
      this.selectedOptions = changes['patchValues']?.currentValue;
      this.selectedOption = this.selectedOptions.length > 0 ? `${this.selectedOptions.length} selected` : 'Select Role';
    }
  }


  toggleOption(e: any, option: any) {
    let index;
    if (e.target.checked) {
      this.selectedOptions.push(option);
    } else {
      if (this.selfDetails?.enrollmentType == 'Admin') {
        index = this.selectedOptions.findIndex((item: any) => item._id === option._id);
      } else {
        index = this.selectedOptions.findIndex((item: any) => item.value === option.value);
      }
      this.selectedOptions.splice(index, 1);
    }
    this.SendSelectedOptions.emit(this.selectedOptions);
    this.selectedOption = this.selectedOptions.length > 0 ? `${this.selectedOptions.length} selected` : 'Select Role';
  }

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: HTMLElement) {
    // Check if the clicked element is inside the dropdown or the dropdown label
    const dropdownElement = this.elementRef.nativeElement.querySelector('.custom-dropdown');
    if (!dropdownElement.contains(target)) {
      this.isDropdownOpen = false;
    }
  }

}
